(function () {
  function initHeroSlider(root) {
    if (!root || root.dataset.tgHeroInit === '1') return;
    root.dataset.tgHeroInit = '1';

    var track = root.querySelector('.tg-hero__track');
    var originalSlides = Array.prototype.slice.call(root.querySelectorAll('.tg-hero__slide'));
    var dots = root.querySelectorAll('.tg-hero__dot');
    var prevBtn = root.querySelector('.tg-hero__arrow--prev');
    var nextBtn = root.querySelector('.tg-hero__arrow--next');
    if (!track || originalSlides.length === 0) return;

    var total = originalSlides.length;

    // Infinite loop: clone last → prepend, clone first → append.
    // Visible left/right neighbors at initial load eliminate the blank space.
    if (total > 1) {
      var firstClone = originalSlides[0].cloneNode(true);
      var lastClone = originalSlides[total - 1].cloneNode(true);
      firstClone.classList.remove('is-active');
      lastClone.classList.remove('is-active');
      firstClone.setAttribute('data-clone', '1');
      lastClone.setAttribute('data-clone', '1');
      track.appendChild(firstClone);
      track.insertBefore(lastClone, track.firstChild);
    }

    // Re-query after cloning
    var slides = root.querySelectorAll('.tg-hero__slide');
    // Logical index (0..total-1) → dots / active state
    var index = 0;
    // Visual index across slides[] (including clones).
    // 0 = lastClone, 1..total = real slides, total+1 = firstClone.
    var visualIndex = total > 1 ? 1 : 0;
    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.autoplayInterval, 10) || 6000;
    var timer = null;

    function getSlidePercent() {
      if (window.matchMedia('(max-width: 749px)').matches) return 85;
      var pcWidth = getComputedStyle(root).getPropertyValue('--tg-hero-slide-pc').trim();
      return parseFloat(pcWidth) || 50;
    }

    function setOffset(animate) {
      var slidePercent = getSlidePercent();
      var offset = 50 - slidePercent / 2 - visualIndex * slidePercent;
      if (animate) {
        track.style.transform = 'translateX(' + offset + '%)';
      } else {
        // Disable transitions on track AND slides so the visual swap
        // (transform + is-active toggle) is invisible to the user.
        var slidesArr = Array.prototype.slice.call(slides);
        track.style.transition = 'none';
        slidesArr.forEach(function (s) { s.style.transition = 'none'; });
        track.style.transform = 'translateX(' + offset + '%)';
        // force reflow so the next style change re-enables transition cleanly
        // eslint-disable-next-line no-unused-expressions
        track.offsetHeight;
        track.style.transition = '';
        slidesArr.forEach(function (s) { s.style.transition = ''; });
      }
    }

    function updateActiveStates() {
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === visualIndex);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
    }

    // Pre-emptive snap: if we're currently sitting on a clone (because the user
    // clicked again before the previous transitionend fired), snap to the real
    // position with no animation BEFORE applying the next move.
    // Critical: re-toggle is-active onto the REAL slide so the centered slide
    // never appears transparent after the wrap-around.
    function snapBackIfOnClone() {
      if (total <= 1) return;
      if (visualIndex === 0) {
        visualIndex = total;
        setOffset(false);
        updateActiveStates();
      } else if (visualIndex === total + 1) {
        visualIndex = 1;
        setOffset(false);
        updateActiveStates();
      }
    }

    function go(targetLogicalIndex, direction) {
      if (total <= 1) return;

      snapBackIfOnClone();

      if (direction === 'next') {
        visualIndex = visualIndex + 1;
      } else if (direction === 'prev') {
        visualIndex = visualIndex - 1;
      } else {
        // dot jump: go directly to that real slide (no clone path)
        visualIndex = targetLogicalIndex + 1;
      }

      index = ((targetLogicalIndex % total) + total) % total;
      setOffset(true);
      updateActiveStates();
    }

    function next() { go((index + 1) % total, 'next'); }
    function prev() { go((index - 1 + total) % total, 'prev'); }

    // Snap clone → real with no animation after the visual transition ends.
    track.addEventListener('transitionend', function (e) {
      if (e.propertyName && e.propertyName !== 'transform') return;
      snapBackIfOnClone();
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i); restart(); });
    });

    function start() {
      if (!autoplay || total <= 1) return;
      timer = setInterval(next, interval);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function restart() { stop(); start(); }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    window.addEventListener('resize', function () { setOffset(false); });

    var swipeTarget = root.querySelector('.tg-hero__viewport') || root;
    if (window.TgTouchSlider) {
      window.TgTouchSlider.bind(
        swipeTarget,
        function () { prev(); restart(); },
        function () { next(); restart(); }
      );
    }

    setOffset(false);
    updateActiveStates();
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-tg-hero]').forEach(initHeroSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-tg-hero]');
    if (root) initHeroSlider(root);
  });
})();
